import { Component, ElementRef, OnInit } from '@angular/core';
const SOCIAL_BUTTON_ATTRIBUTES: SocialButtons[] = [
  'facebook-button',
  'trans-button',
  'google-button',
];
@Component({
    selector: 'gl-social-button, button[facebook-button], button[google-button], button[trans-button]',
    templateUrl: './facebook-button.component.html',
    styleUrls: ['./facebook-button.component.scss'],
    standalone: false
})
export class FacebookButtonComponent implements OnInit {
  public buttonType: SocialButtons;

  constructor(private el: ElementRef<HTMLElement>) {}

  public ngOnInit(): void {
    SOCIAL_BUTTON_ATTRIBUTES.forEach((attr) => {
      if (this.hasAttribute(attr)) {
        this.el.nativeElement.classList.add(attr);
        this.buttonType = attr;
      }
    });
  }

  private hasAttribute(attribute: string) {
    return this.el.nativeElement.hasAttribute(attribute);
  }
}

export type SocialButtons = 'facebook-button' | 'trans-button' | 'google-button';
